/**
 * https://developers.google.com/my-business/reference/businessinformation/rest/v1/ErrorCode?hl=fr
 */
export enum GmbErrorCode {
    ERROR_CODE_UNSPECIFIED = 'ERROR_CODE_UNSPECIFIED',
    INVALID_ATTRIBUTE_NAME = 'INVALID_ATTRIBUTE_NAME',
    ASSOCIATE_OPERATION_ON_VERIFIED_LOCATION = 'ASSOCIATE_OPERATION_ON_VERIFIED_LOCATION',
    ASSOCIATE_LOCATION_INVALID_PLACE_ID = 'ASSOCIATE_LOCATION_INVALID_PLACE_ID',
    LAT_LNG_UPDATES_NOT_PERMITTED = 'LAT_LNG_UPDATES_NOT_PERMITTED',
    PO_BOX_IN_ADDRESS_NOT_ALLOWED = 'PO_BOX_IN_ADDRESS_NOT_ALLOWED',
    BLOCKED_REGION = 'BLOCKED_REGION',
    MISSING_BOTH_PHONE_AND_WEBSITE = 'MISSING_BOTH_PHONE_AND_WEBSITE',
    MISSING_STOREFRONT_ADDRESS_OR_SAB = 'MISSING_STOREFRONT_ADDRESS_OR_SAB',
    LAT_LNG_TOO_FAR_FROM_ADDRESS = 'LAT_LNG_TOO_FAR_FROM_ADDRESS',
    LAT_LNG_REQUIRED = 'LAT_LNG_REQUIRED',
    INVALID_CHARACTERS = 'INVALID_CHARACTERS',
    FORBIDDEN_WORDS = 'FORBIDDEN_WORDS',
    INVALID_INTERCHANGE_CHARACTERS = 'INVALID_INTERCHANGE_CHARACTERS',
    FIELDS_REQUIRED_FOR_CATEGORY = 'FIELDS_REQUIRED_FOR_CATEGORY',
    STOREFRONT_REQUIRED_FOR_CATEGORY = 'STOREFRONT_REQUIRED_FOR_CATEGORY',
    ADDRESS_MISSING_REGION_CODE = 'ADDRESS_MISSING_REGION_CODE',
    ADDRESS_EDIT_CHANGES_COUNTRY = 'ADDRESS_EDIT_CHANGES_COUNTRY',
    SPECIAL_HOURS_SET_WITHOUT_REGULAR_HOURS = 'SPECIAL_HOURS_SET_WITHOUT_REGULAR_HOURS',
    INVALID_TIME_SCHEDULE = 'INVALID_TIME_SCHEDULE',
    INVALID_HOURS_VALUE = 'INVALID_HOURS_VALUE',
    OVERLAPPED_SPECIAL_HOURS = 'OVERLAPPED_SPECIAL_HOURS',
    INCOMPATIBLE_MORE_HOURS_TYPE_FOR_CATEGORY = 'INCOMPATIBLE_MORE_HOURS_TYPE_FOR_CATEGORY',
    DUPLICATE_CHILDREN_LOCATIONS = 'DUPLICATE_CHILDREN_LOCATIONS',
    INCOMPATIBLE_SERVICE_AREA_AND_CATEGORY = 'INCOMPATIBLE_SERVICE_AREA_AND_CATEGORY',
    INVALID_SERVICE_AREA_PLACE_ID = 'INVALID_SERVICE_AREA_PLACE_ID',
    INVALID_AREA_TYPE_FOR_SERVICE_AREA = 'INVALID_AREA_TYPE_FOR_SERVICE_AREA',
    OPENING_DATE_TOO_FAR_IN_THE_FUTURE = 'OPENING_DATE_TOO_FAR_IN_THE_FUTURE',
    OPENING_DATE_MISSING_YEAR_OR_MONTH = 'OPENING_DATE_MISSING_YEAR_OR_MONTH',
    OPENING_DATE_BEFORE_1AD = 'OPENING_DATE_BEFORE_1AD',
    TOO_MANY_ENTRIES = 'TOO_MANY_ENTRIES',
    INVALID_PHONE_NUMBER = 'INVALID_PHONE_NUMBER',
    INVALID_PHONE_NUMBER_FOR_REGION = 'INVALID_PHONE_NUMBER_FOR_REGION',
    MISSING_PRIMARY_PHONE_NUMBER = 'MISSING_PRIMARY_PHONE_NUMBER',
    THROTTLED = 'THROTTLED',
    UNSUPPORTED_POINT_RADIUS_SERVICE_AREA = 'UNSUPPORTED_POINT_RADIUS_SERVICE_AREA',
    INVALID_CATEGORY = 'INVALID_CATEGORY',
    CANNOT_REOPEN = 'CANNOT_REOPEN',
    INVALID_BUSINESS_OPENING_DATE = 'INVALID_BUSINESS_OPENING_DATE',
    INVALID_LATLNG = 'INVALID_LATLNG',
    PROFILE_DESCRIPTION_CONTAINS_URL = 'PROFILE_DESCRIPTION_CONTAINS_URL',
    LODGING_CANNOT_EDIT_PROFILE_DESCRIPTION = 'LODGING_CANNOT_EDIT_PROFILE_DESCRIPTION',
    INVALID_URL = 'INVALID_URL',
    INVALID_ADDRESS = 'INVALID_ADDRESS',
    PARENT_CHAIN_CANNOT_BE_THE_LOCATION_ITSELF = 'PARENT_CHAIN_CANNOT_BE_THE_LOCATION_ITSELF',
    RELATION_CANNOT_BE_THE_LOCATION_ITSELF = 'RELATION_CANNOT_BE_THE_LOCATION_ITSELF',
    MISSING_ADDRESS_COMPONENTS = 'MISSING_ADDRESS_COMPONENTS',
    READ_ONLY_ADDRESS_COMPONENTS = 'READ_ONLY_ADDRESS_COMPONENTS',
    STRING_TOO_LONG = 'STRING_TOO_LONG',
    STRING_TOO_SHORT = 'STRING_TOO_SHORT',
    REQUIRED_FIELD_MISSING_VALUE = 'REQUIRED_FIELD_MISSING_VALUE',
    ATTRIBUTE_PROVIDER_URL_NOT_ALLOWED = 'ATTRIBUTE_PROVIDER_URL_NOT_ALLOWED',
    ATTRIBUTE_INVALID_ENUM_VALUE = 'ATTRIBUTE_INVALID_ENUM_VALUE',
    ATTRIBUTE_NOT_AVAILABLE = 'ATTRIBUTE_NOT_AVAILABLE',
    ATTRIBUTE_CANNOT_BE_REPEATED = 'ATTRIBUTE_CANNOT_BE_REPEATED',
    ATTRIBUTE_TYPE_NOT_COMPATIBLE_FOR_CATEGORY = 'ATTRIBUTE_TYPE_NOT_COMPATIBLE_FOR_CATEGORY',
    ADDRESS_REMOVAL_NOT_ALLOWED = 'ADDRESS_REMOVAL_NOT_ALLOWED',
    AMBIGUOUS_TITLE = 'AMBIGUOUS_TITLE',
    INVALID_CATEGORY_FOR_SAB = 'INVALID_CATEGORY_FOR_SAB',
    RELATION_ENDPOINTS_TOO_FAR = 'RELATION_ENDPOINTS_TOO_FAR',
    INVALID_SERVICE_ITEM = 'INVALID_SERVICE_ITEM',
    SERVICE_ITEM_LABEL_NO_DISPLAY_NAME = 'SERVICE_ITEM_LABEL_NO_DISPLAY_NAME',
    SERVICE_ITEM_LABEL_DUPLICATE_DISPLAY_NAME = 'SERVICE_ITEM_LABEL_DUPLICATE_DISPLAY_NAME',
    SERVICE_ITEM_LABEL_INVALID_UTF8 = 'SERVICE_ITEM_LABEL_INVALID_UTF8',
    FREE_FORM_SERVICE_ITEM_WITH_NO_CATEGORY_ID = 'FREE_FORM_SERVICE_ITEM_WITH_NO_CATEGORY_ID',
    FREE_FORM_SERVICE_ITEM_WITH_NO_LABEL = 'FREE_FORM_SERVICE_ITEM_WITH_NO_LABEL',
    SERVICE_ITEM_WITH_NO_SERVICE_TYPE_ID = 'SERVICE_ITEM_WITH_NO_SERVICE_TYPE_ID',
    INVALID_LANGUAGE = 'INVALID_LANGUAGE',
    PRICE_CURRENCY_MISSING = 'PRICE_CURRENCY_MISSING',
    PRICE_CURRENCY_INVALID = 'PRICE_CURRENCY_INVALID',
    SERVICE_TYPE_ID_DUPLICATE = 'SERVICE_TYPE_ID_DUPLICATE',
    PIN_DROP_REQUIRED = 'PIN_DROP_REQUIRED',
    STALE_DATA = 'STALE_DATA',
    PHONE_NUMBER_EDITS_NOT_ALLOWED = 'PHONE_NUMBER_EDITS_NOT_ALLOWED',
    MULTIPLE_ORGANIZATIONALLY_PART_OF_RELATION = 'MULTIPLE_ORGANIZATIONALLY_PART_OF_RELATION',
    UNVERIFIED_LOCATION = 'UNVERIFIED_LOCATION',
    INVALID_LOCATION_CATEGORY = 'INVALID_LOCATION_CATEGORY',

    // Action links errors
    SCALABLE_DEEP_LINK_INVALID_MULTIPLICITY = 'SCALABLE_DEEP_LINK_INVALID_MULTIPLICITY',
    LINK_ALREADY_EXISTS = 'LINK_ALREADY_EXISTS',
    URL_PROVIDER_NOT_ALLOWED = 'URL_PROVIDER_NOT_ALLOWED',

    // Other errors
    // When receiving a 409 error (info is already being updated)
    TOO_MANY_UPDATES = 'TOO_MANY_UPDATES',
    // When a social media url is valid but doesn't match with the business profile
    INVALID_SOCIAL_MEDIA_PROFILE_URL = 'INVALID_SOCIAL_MEDIA_PROFILE_URL',
}

export enum GmbMediaErrorCode {
    IMAGE_TOO_SMALL = 'IMAGE_TOO_SMALL',
    IMAGE_FORMAT_NOT_SUPPORTED = 'IMAGE_FORMAT_NOT_SUPPORTED',
}

export enum GmbMenuMediaErrorCode {
    FAILED_TO_UPLOAD_MEDIA = 'FAILED_TO_UPLOAD_MEDIA',
    FAILED_TO_SYNC_MEDIA = 'FAILED_TO_SYNC_MEDIA',
}

export enum GmbStructuredMenuErrorCode {
    FAILED_TO_UPDATE_STRUCTURED_MENU = 'FAILED_TO_UPDATE_STRUCTURED_MENU',
}
